module.exports = __webpack_public_path__ + "static/media/SUVATGraph1.7a58b501.svg";